import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, CreditCard } from "lucide-react";

interface StatsCardsProps {
  totalCredits: number;
  totalOps: number;
  activeAccountsCount: number; // passed separately if needed, or derived
}

const StatsCards = ({ totalCredits, totalOps }: StatsCardsProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-2">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">סה״כ קרדיטים (30 ימים)</CardTitle>
          <CreditCard className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalCredits.toLocaleString()}</div>
          <p className="text-xs text-muted-foreground">שימוש מצטבר בכל המערכת</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">סה״כ פעולות (30 ימים)</CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalOps.toLocaleString()}</div>
          <p className="text-xs text-muted-foreground">מספר קריאות ל-API</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatsCards;
